// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module--footer--3dt86","social__display__area":"footer-module--social__display__area--5hwqu"};